import { render, staticRenderFns } from "./documentLibrary.vue?vue&type=template&id=66d957fe&"
import script from "./documentLibrary.vue?vue&type=script&lang=js&"
export * from "./documentLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports